import { convertLabelToKey } from 'utils/helpers'
import { DurationInput } from 'types/input'
import { TextInput } from '../'

const Duration = ({
  startText,
  endText,
  register,
  title,
  className = '',
}: DurationInput) => {
  const startTitle = convertLabelToKey(`${title} ${startText}`)
  const endTitle = convertLabelToKey(`${title} ${endText}`)

  return (
    <div className={`mt-1 ${className}`}>
      <div className="text-xs font-semibold text-sidebar-primary">{title}</div>
      <div className="mt-2 flex items-center gap-2 ">
        <div className="w-1/6 text-xs font-medium capitalize text-gray-500">
          {startText}
        </div>
        <TextInput register={register} name={startTitle} />
      </div>
      <div className="mt-2 flex items-center gap-2 text-gray-500">
        <div className="w-1/6 text-xs capitalize">{endText}</div>
        <TextInput register={register} name={endTitle} />
      </div>
    </div>
  )
}

export default Duration
